import type { CustomerConsentDto } from '~/models/customer/CustomerConsent.api.model';
import FetchFactory from '../factory';
import type { TeresPersonaIdentity } from '~/models/customer/TeresPersonaIdentity.api.model';
import type { DeliveryAddress } from '~/models/DeliveryAddress.model';
import type {
  ValidateNumberTransferRequest,
  ValidateNumberTransferResponse,
} from '~/models/customer/ValidateNumberTransfer.api.model';
const CONTROLLER_PATH = `/api-electra/Customer/`;

export type CustomerConsentResponse = {
  CustomerConsents: CustomerConsentDto[];
};

class CustomerModule extends FetchFactory<any> {
  async getDeliveryAddress(): Promise<DeliveryAddress> {
    const url = `${CONTROLLER_PATH}GetDeliveryAddress`;

    return await this.get(url);
  }

  /*
  TODO ta bort dessa om det funkar
  async setDownPayment(downPaymentTimeInMonths: number) {
    const url = `${CONTROLLER_PATH}SetSelectedDownPayments/${downPaymentTimeInMonths}`;
    return await this.post(url, {});
  }

 
  async getSelectedDownPayment() {
    const url = `${CONTROLLER_PATH}GetSelectedDownPayments`;

    return await this.get(url, {});
  }
  */

  async SetEmailAddress(email: string) {
    const url = `${CONTROLLER_PATH}SetEmailAddress`;

    return await this.post(url, { EmailAddress: email });
  }

  async GetEmailAddress() {
    const url = `${CONTROLLER_PATH}GetEmailAddress`;

    return await this.get(url, {});
  }

  async GetCustomerConsents(): Promise<CustomerConsentResponse> {
    const url = `${CONTROLLER_PATH}GetCustomerConsents`;

    return await this.get(url);
  }

  async GetCustomerSsnCensored(): Promise<string> {
    const url = `${CONTROLLER_PATH}GetSsnCensored`;

    return await this.get(url);
  }

  async GetSamplesOfTestPersonas(): Promise<TeresPersonaIdentity[]> {
    const url = `${CONTROLLER_PATH}FetchUniformlySampledPersonas`;

    return await this.get(url);
  }
  async getCustomerPlansEligibleForFamilyConnections() {
    const url = `${CONTROLLER_PATH}GetCustomerPlansEligibleForFamilyConnections`;
    return await this.get(url);
  }

  async setSsnForTestEnvironmentBankIdPassthrough(
    teresSsn: string,
  ): Promise<void> {
    const url = `${CONTROLLER_PATH}SetSsnForTestEnvironmentBankIdPassthrough`;
    return await this.post(url, { teresSsn });
  }

  async RemoveDiscountCouponCode(code: string) {
    const url = `${CONTROLLER_PATH}RemoveDiscountCouponCode?couponCode=${code}`;

    return await this.get(url);
  }

  async isCustomerBankIDVerificationRequired(): Promise<boolean> {
    const url = `${CONTROLLER_PATH}IsCustomerBankIDVerificationRequired`;

    return await this.get(url);
  }

  async CheckBindingPeriod(msisdn: string): Promise<{ AllowRenewal: boolean }> {
    const url = `${CONTROLLER_PATH}CheckBindingPeriod?msisdn=${msisdn}`;
    return await this.get(url);
  }

  async ValidateNumberTransfer(
    validateNumberTransferRequest: ValidateNumberTransferRequest,
  ): Promise<ValidateNumberTransferResponse | undefined> {
    try {
      const url = `${CONTROLLER_PATH}ValidateNumberTransfer`;
      return await this.post(url, validateNumberTransferRequest);
    } catch (e) {
      return undefined;
    }
  }
}

export default CustomerModule;
